import React, { useState } from 'react'

import Layout from '../components/Layout'
import Button from '../components/Button'
import BackButton from '../components/BackButton'
import Text from '../components/Text'
import ActionBar from '../components/ActionBar'

const Form = ({ data, setData, onNext, onBack }) => {
  const [acceptedPrivacyPolicy, setAcceptedPrivacyPolicy] = useState(false)

  return (
    <Layout>
      <Layout>
        <Text large>Please provide the following information</Text>
      </Layout>

      <Layout id="form">
        <label>
          <Text>Age</Text>

          <input
            type="number"
            onChange={e => setData({ age: e.target.value })}
            value={data.age || ''}
            placeholder="45"
          />
        </label>

        <label>
          <Text>Biological gender</Text>

          <select onChange={e => setData({ gender: e.target.value })} value={data.gender}>
            <option value="f">Female</option>
            <option value="m">Male</option>
          </select>
        </label>
      </Layout>

      <Layout>
        <br/>
        <a href="/privacy-policy.pdf" target="_blank">Read the privacy policy</a>

        <label className="checkbox">
          <input
            type="checkbox"
            onChange={e => setAcceptedPrivacyPolicy(e.target.checked)}
            checked={acceptedPrivacyPolicy}
          />

          <Text>I accept the privacy policy</Text>
        </label>
      </Layout>

      <ActionBar active={acceptedPrivacyPolicy && data.age}>
        <BackButton onClick={onBack} />

        <Button onClick={onNext} disabled={!acceptedPrivacyPolicy || !data.age}>
          Next
        </Button>
      </ActionBar>
    </Layout>
  )
}

export default Form
